<template>
  <v-container>
    <equipment-tab></equipment-tab>
    <v-container>
      <base-material-card
        v-if="inspections"
        icon="mdi-clipboard-text-outline"
        color="primary"
        inline
        class="px-5 my-12 py-3"
      >
        <template v-slot:after-heading>
          <div class="title text-no-wrap font-weight-bold">
            {{ $t("inspectionList.inspectionList") }}
            <export-2-excel
              :filename="`meru-inspection-list-${equipmentProfile.equipTag}`"
              sheetname="inspection-list"
              :datos="exportDatos"
            ></export-2-excel>
          </div>
        </template>

        <v-btn
          @click="goToInspection"
          fab
          color="#730D0B"
          absolute=""
          top
          right=""
          ><v-icon color="white">mdi-plus</v-icon></v-btn
        >
        <!--  <v-btn
        @click="dialog = true"
        fab
        color="blue"
        absolute=""
        top
        right=""
        class="mr-16"
        ><v-icon color="white">mdi-camera</v-icon></v-btn
      > -->
        <v-data-table
          @click:row="rowClick"
          loading-text="Loading... Please wait"
          :headers="headers"
          sort-by="dateCreated"
          sort-desc=""
          :items="inspections"
          :footer-props="{
            itemsPerPageText: $t('repairList.itemsPerPage'),
            itemsPerPageAllText: $t('repairList.itemsPerPageAllText')
          }"
          ><template v-slot:[`item.resume`]="{ item }">
            <v-icon
              :color="
                item.resume && item.resume.status.color
                  ? item.resume.status.color
                  : '#008450'
              "
              >mdi-circle</v-icon
            >
            {{ $t("inspectionList.zone") }}:
            {{
              item.resume.status && item.resume.status.name
                ? translate(item.resume.status.name)
                : "Smooth"
            }}
          </template>

          <template v-slot:[`item.dateCreated`]="{ item }">
            {{ FixingDate(item.dateCreated) | capitalize }}
          </template></v-data-table
        >
      </base-material-card>
    </v-container></v-container
  >
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import gpsBusinessLogic from "@/mixins/gpsBusinessLogic";
export default {
  data() {
    return {
      /*  pointGPS: [7.827676, -72.225234] */

      headers: [
        {
          text: this.$t("reliability.status"),
          value: "resume"
        },
        { text: this.$t("inspectionList.inspectionDate"), value: "dateCreated" }
      ]
    };
  },
  mixins: [gpsBusinessLogic],
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    try {
      await this.$store.dispatch(
        "inspections/bindInspectionsOfEquipment",
        this.$route.params.id
      );
      loading.close();
    } catch (error) {
      loading.close();
      this.$router.push("Error");
    }
  },
  computed: {
    exportDatos() {
      if (this.inspections) {
        const header = this.headers.map(h => {
          return h.text;
        });
        const mapedData = this.inspections.map(e => {
          const resume =
            e.resume.status && e.resume.status.name
              ? e.resume.status.name
              : "Smooth";
          const dateCreated = new Intl.DateTimeFormat("es-VE").format(
            e.dateCreated.toDate()
          );
          return [resume, dateCreated];
        });
        const datos = [
          ["Asset Tag", this.equipmentProfile.equipTag],
          [...header],
          ...mapedData
        ];
        return datos;
      } else return [["Server", "Error"]];
    },
    ...mapState("auth", ["user"]),
    ...mapState("inspections", ["inspections"]),
    ...mapState("equipments", ["equipmentProfile"])
  },
  methods: {
    rowClick: function(item) {
      this.$router.push({
        name: "InspectionProfile",
        params: { id: item.id }
      });
      //item  - selected item
    },
    FixingDate: function(value) {
      if (value) {
        const lang = this.user?.language ? this.user.language : "en";
        moment.locale(lang);

        return moment.unix(value.seconds).format("MMMM D YYYY, h:mm:ss a");
      } else {
        return null;
      }
    },
    translate: function(item) {
      var temp = item;

      temp = temp.replace("Smooth", this.$t("reliability.conditions.smooth"));
      temp = temp.replace("Warning", this.$t("reliability.conditions.warning"));
      temp = temp.replace("Alarm", this.$t("reliability.conditions.alarm"));

      return temp;
    }
  }
};
</script>
<style scoped>
.error {
  font-weight: bold;
  color: #730d0b;
}
</style>
